module.exports = __webpack_public_path__ + "static/media/code.deeac9c8.svg";